export default __webpack_public_path__ + "static/media/leftrobo.4f19d613.svg";